define(function(require) {
	// general
	const Backbone = require('backbone');
	const Modal = require('backbone.modal');
	const Radio = require('backbone.radio');
	const AddAttachmentChannel = Radio.channel('addAttachmentChannel');
	const ViewManager = require('civicsUtils/view_manager');
	const Utils = require('civicsUtils/general_utilities');
	// models
	const attachmentModel = require('civicsModels/attachment_model');
	// collections
	const attachmentsCollection = require('civicsCollections/attachment_collection');
	const documentTypeCollection = require('civicsCollections/document_type_collection');
	// templates
	const AddAttachmentTemplate = require('civicsViews/attachments/templates/t_cpv_add_attachment.hbs');
	// views
	const rowView = require('civicsViews/attachments/v_itv_add_attachment');

	return Marionette.CompositeView.extend({
		initialize: function(options) {
			// if (__DEV__) console.log('cpv_add_attachments -- initialize');
			this.attachmentModel = new attachmentModel();
			this.savedAttachments = new attachmentsCollection();
			this.productFamily = options.itemOptions.productFamily;
			this.config = options.config ? options.config : {};
			this.isAddProcess = options.isAddProcess;
			this.config.globalConfig = ViewManager.globalConfig();
			this.catalog = this.getCatalog();
			this.uploadedKeys = []; // List of attachmentkeys of files that have been uploaded, these still need to be linked to permit et al.
			this.collection = this.savedAttachments;
			this.modalRegion = options.modalRegion;
			this.itemOptions = options.itemOptions;
			if (ViewManager.versionRange('8.8.0.0')) {
				this.documentTypePromise = $.Deferred();
				this.fetchDocumentTypes();
			}
		},
		template: AddAttachmentTemplate,
		className: 'add-attach',
		childView: rowView,
		childViewContainer: '.saved-attachments',
		childEvents: {
			'attachment:post:save': 'onPostSaveAttachment',
			'attachment:before:save': 'onValidateAttachment',
			'attachment:remove': 'onRemoveAttachment',
		},
		childViewOptions: function (model, index) {
			let options = $.extend({}, this.itemOptions);
			options.attachment_index = index;
			return options;
		},
		ui: {
			$backButton: '.back-modal-button',
			$closeButton: '.close-modal-button',
			$dropFile: '.drop-file',
			$saveButton: '.save-modal-button',
			$selectFiles: '.select-file',
			$genericLabel: '.generic-label',
		},
		events: {
			'click .back-modal-button': 'closeModal',
			'click .save-modal-button': 'onSaveAndUpload',
			'click .close-modal-button': 'closeModal',
			'click .bbm-btn-close': 'closeModal',
			'drop .attach-modal': 'dropHandler',
			'dragover .attach-modal': 'dragEnter',
			'click .browse-link': 'openFileSelect',
			'change .select-file': 'saveSelectedFile',

		},
		onShow: function() {
			this.setButtons(false);
			this.ui.$saveButton.prop("disabled", true);

		},
		onRender: function() {
			if (ViewManager.versionRange('8.8.0.0')) {
				var genericLabel = i18n.t('CIVICS.ATTACHMENTS.GENERIC_LABEL');
				if (genericLabel.length > 0)
					this.ui.$genericLabel.html(genericLabel);
			}

			if (this.itemOptions.isAddProcess)
				this.ui.$saveButton.html(i18n.t('CIVICS.COMMON.SAVE'));

		},
		dragEnter: function(e) {
			var evt = e.originalEvent;
			evt.preventDefault();
		},
		dropHandler: function(e) {
			var self = this;

			var evt = e.originalEvent;
			evt.preventDefault();
			evt.stopPropagation();
			e.preventDefault();
			e.stopPropagation();

			if (ViewManager.versionRange('8.8.0.0')) {
				$.when(self.documentTypePromise).done(function() {
					var files = evt.dataTransfer.files;
					if (files) {
						self.saveForUpload(files);
					}
				});
			} else {
				var files = evt.dataTransfer.files;
				if (files) {
					self.saveForUpload(files);
				}
			}

		},
		setButtons: function(showClose) {
			if (showClose && showClose === true) {
				this.ui.$backButton.hide();
				this.ui.$saveButton.hide();
				this.ui.$dropFile.hide();
				this.ui.$closeButton.show();
			} else {
				this.ui.$backButton.show();
				this.ui.$saveButton.show();
				this.ui.$dropFile.show();
				this.ui.$closeButton.hide();
			}
		},
		isDuplicateFile: function(fileName) {
			var self = this;
			var attachments = self.collection.where({ fileName: fileName });
			if (attachments.length > 0) {
				return true;
			}

			return false;
		},
		saveForUpload: function(files) {
			var self = this;
			// We are saving a new file.  Save off description from old files
			this.children.each(function(view) {
				view.onSaveDescription();
			});

			_.each(files, function(myFile) {
				// Sanitize filename to remove invalid characters before upload
				var sanitizedName = Utils.sanitizeFileNameForUpload(myFile.name);
				// Create new File object with sanitized name (browser File object is immutable)
				var sanitizedFile = new File([myFile], sanitizedName, { type: myFile.type });
				var myAttachment = new attachmentModel();
				myAttachment.set('file', sanitizedFile);
				myAttachment.set('fileName', sanitizedName);
				myAttachment.set('catalog', self.catalog);

				if( self.config.IsForBilling)
					myAttachment.set('accountId', self.config.BillingAccountKey);

				//we set title as same with filename for versions lower than 8.8.0.0
				if (!ViewManager.versionRange('8.8.0.0')) {
					myAttachment.set('title', myFile.name);
				}

				if (!self.isDuplicateFile(myFile.name)) {
					self.savedAttachments.add(myAttachment);
				}
			});
			this.render();
			this.setButtons(false);
		},
		openFileSelect: function(e) {
			var self = this;
			var evt = e.originalEvent;
			evt.preventDefault();

			if (ViewManager.versionRange('8.8.0.0')) {
				$.when(self.documentTypePromise).done(function() {
					$('.select-file').click();
				});
			} else {
				$('.select-file').click();
			}

		},
		saveSelectedFile: function() {
			var self = this;

			// We are saving a new file.  Save off description from old files
			this.children.each(function(view) {
				view.onSaveDescription();
			});

			self.ui.$saveButton.prop("disabled", false);

			var fileList = this.ui.$selectFiles[0].files;

			_.each(fileList, function(myFile) {
				// Sanitize filename to remove invalid characters before upload
				var sanitizedName = Utils.sanitizeFileNameForUpload(myFile.name);
				// Create new File object with sanitized name (browser File object is immutable)
				var sanitizedFile = new File([myFile], sanitizedName, { type: myFile.type });
				var myAttachment = new attachmentModel();
				myAttachment.set('file', sanitizedFile);
				myAttachment.set('fileName', sanitizedName);
				myAttachment.set('catalog', self.catalog);

				if( self.config.IsForBilling == true)
					myAttachment.set('accountId', self.config.BillingAccountKey);

				//we set title as same with filename for versions lower than 8.8.0.0
				if (!ViewManager.versionRange('8.8.0.0')) {
					myAttachment.set('title', myFile.name);
				}

				if (!self.isDuplicateFile(myFile.name)) {
					self.savedAttachments.add(myAttachment);
				}
			});
			this.render();
			this.setButtons(false);
		},
		onSaveAndUpload: function() {
			var self = this;
			var hasError = false;
			self.ui.$dropFile.hide();
			self.ui.$saveButton.prop("disabled", true);
			setTimeout(function() {
				if (typeof self.ui.$saveButton === 'object')
					self.ui.$saveButton.prop('disabled', false);
			}, 500);

			ViewManager.loading(true);
			var defArr = [];
			this.children.each(function(view, index) {
				if (typeof view.isUploaded === 'undefined' && !view.isUploaded) {
					if (view.isAddProcess) {
						view.validateChildViewAttachment(view);
						if (view.hasValidAttachment) //if it pass the first check on the AddInstrument, proceed with the second attachment validation method.
							view.validateChildViewAttachment2(self.catalog);
					} else {
						view.validateChildViewAttachment2(self.catalog);
					}
					if (view.hasValidAttachment) {
						defArr.push(view.onUploadSave(self.catalog));
					} else {
						hasError = true;
					}
				}
			});

			$.when.apply($, defArr).done(function() {
				ViewManager.loading(false);
				if (hasError) {
					self.setButtons(false);
					self.scrollToError();
				} else {
					//Prevent page from reloading during submit process
					if(!self.isAddProcess)
						window.location.reload(false);
					self.closeModal();
				}
			}).fail(function() {
				ViewManager.loading(false);
				self.setButtons(false);
				self.scrollToError();
			});
		},
		onPostSaveAttachment: function(childView, myModel) {
			childView.isUploaded = true;
			AddAttachmentChannel.trigger('attachments:added', myModel);
		},
		onValidateAttachment: function(view) {
			return AddAttachmentChannel.trigger('attachments:validate', view);
		},
		onRemoveAttachment: function(childView) {
			var self = this;
			// The attachment has not yet been uploaded or added to the database, so we can just remove the child view.
			// remove the model from the collection based on cid.
			this.collection.remove(this.collection.get({ cid: childView.model.cid }));

			this.removeChildView(childView);
			childView.destroy();

			self.ui.$saveButton.prop("disabled", (this.collection.length <= 0));
		},
		getCatalog: function() {
			var catalog;

			switch (this.productFamily.toUpperCase()) {
				case "SERVICEREQUEST":
					catalog = this.config.globalConfig.get("attachments").get("crmCatalog");
					break;
				case "BUILDING":
					catalog = this.config.globalConfig.get("attachments").get("buildingCatalog");
					break;
				case "BUSINESSLICENSE":
					catalog = this.config.globalConfig.get("attachments").get("licenseCatalog");
					break;
				case "CODEENFORCEMENT":
					catalog = this.config.globalConfig.get("attachments").get("caseCatalog");
					break;
				case "PLANNING":
					catalog = this.config.globalConfig.get("attachments").get("planningCatalog");
					break;
				case "PROJECT":
					catalog = this.config.globalConfig.get("attachments").get("projectCatalog");
					break;
				case "TRADELICENSE":
					catalog = this.config.globalConfig.get("attachments").get("tradeCatalog");
					break;
				case "USE":
					catalog = this.config.globalConfig.get("attachments").get("useCatalog");
					break;
				default:
					catalog = this.config.globalConfig.get("attachments").get("defaultCatalog");
			}

			// If the product specific catalog is not set, use the default
			if (!catalog || catalog.length == 0) {
				catalog = this.config.globalConfig.get("attachments").get("defaultCatalog");
			}
			return catalog;
		},
		fetchDocumentTypes: function() {
			var self = this;
			this.documentTypeCollection = new documentTypeCollection();
			//this.documentTypeCollection.urlRoot = this.documentTypeCollection.urlRoot.format(self.catalog);
			this.documentTypeCollection.provider = self.catalog;
			this.documentTypeCollection.isEffective = true;
			this.documentTypeCollection.fetch({
				success: function(m, r, o) {
					self.itemOptions.documentTypeCollection = m;
					self.documentTypePromise.resolve();
				}.bind(this)
			});
		},
		closeModal: function(e, myModel) {
			this.modalRegion.hideModal(() => AddAttachmentChannel.trigger('attachments:done', myModel));
		},
		scrollToError: function() {
			var scrollTop;
			var errorMessage = this.$el.find('.error-message:visible:first').closest('.helper-msg-container');
			var containerModal = $('.bbm-modal');
			var scrollTop = $(containerModal.find(errorMessage).parent()).offset().top - containerModal.offset().top + containerModal.scrollTop();

			if (scrollTop) {
				containerModal.animate({
					scrollTop: scrollTop
				}, 500);
			}

		},
	});
});
